import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: var(--bg-secondary);
  border-radius: ${props => props.theme.borderRadius['2xl']};
  padding: ${props => props.theme.spacing['2xl']};
  max-width: 400px;
  width: 90%;
  box-shadow: ${props => props.theme.shadows.modal};
  pointer-events: auto;
`;

const Title = styled.h2`
  font-size: ${props => props.theme.fontSize.xl};
  font-weight: ${props => props.theme.fontWeight.bold};
  color: var(--text-primary);
  margin-bottom: ${props => props.theme.spacing.md};
  text-align: center;
`;

const Message = styled.p`
  font-size: ${props => props.theme.fontSize.base};
  color: ${props => props.theme.colors.gray[600]};
  margin-bottom: ${props => props.theme.spacing['2xl']};
  text-align: center;
  line-height: 1.6;
  white-space: pre-line;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.md};
`;

const Button = styled.button<{ $primary?: boolean }>`
  flex: 1;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};
  border-radius: ${props => props.theme.borderRadius.xl};
  border: none;
  font-size: ${props => props.theme.fontSize.base};
  font-weight: ${props => props.theme.fontWeight.semibold};
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.$primary ? `
    background-color: ${props.theme.colors.toss.blue};
    color: ${props.theme.colors.white};
    
    &:hover {
      background-color: ${props.theme.colors.primary[700]};
    }
  ` : `
    background-color: ${props.theme.colors.gray[100]};
    color: var(--text-primary);
    
    &:hover {
      background-color: ${props.theme.colors.gray[200]};
    }
  `}
`;

interface ExpirationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

const ExpirationModal: React.FC<ExpirationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title = '인증 시간 만료',
  message = '인증 유효 시간이 만료되었습니다.\n다시 인증 코드를 받아주세요.',
  confirmText = '다시 받기',
  cancelText = '취소',
}) => {
  if (!isOpen) return null;

  return (
    <Overlay onClick={onCancel}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <Title>{title}</Title>
        <Message>{message.replace(/&#10;/g, '\n')}</Message>
        <ButtonGroup>
          {onCancel && (
            <Button onClick={onCancel}>
              {cancelText}
            </Button>
          )}
          <Button $primary onClick={onConfirm}>
            {confirmText}
          </Button>
        </ButtonGroup>
      </ModalContainer>
    </Overlay>
  );
};

export default ExpirationModal;
